import React, { FC } from 'react';

import { TextView } from 'components';
import { CoreModal } from 'components/ModalViewV3';

interface FooterProps {
  onClick?: () => void;
  label: string;
}

interface ErrorModalProps {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  message?: string;
  subMessage?: string;
  showFooter?: boolean;
  footerProps?: FooterProps;
  fromGlobalState?: boolean;
}

const ErrorModal: FC<ErrorModalProps> = ({
  isModalOpen,
  setIsModalOpen,
  message = 'Error!',
  subMessage,
}) => {
  const handleCloseModal = () => {
    // Close the modal
    setIsModalOpen(false);
  };

  return (
    <CoreModal
      maxWidth={'auto'}
      showCloseIcon={true}
      onModalClose={handleCloseModal}
      open={isModalOpen}
      transparentOverlay
      closeOnOutsideClick
    >
      <div className="px-4 py-6 flex flex-col justify-center items-center">
        {/* <ImageView
          className="w-4 h-4 my-2"
          style={{ width: '50px', height: '50px' }}
          src={deleteIcon01}
        /> */}
        <div className="flex flex-col gap-4">
          <TextView
            text={message}
            size={16}
            lineHeight={24}
            weight="500"
            color="#000"
            align="center"
          />
          {subMessage && (
            <TextView
              text={subMessage}
              size={14}
              lineHeight={20}
              color="#4b5565"
              align="center"
            />
          )}
        </div>
      </div>
    </CoreModal>
  );
};

export default ErrorModal;
